import type { GPSummaryUserInfo, GPSummaryMeta } from "../../../types/gpSummary";
import Card from "./Card";

interface PatientInfoCardProps {
  userInfo: GPSummaryUserInfo;
  meta: GPSummaryMeta;
}

function InfoRow({ label, value }: { label: string; value: string | null }) {
  return (
    <div className="flex justify-between items-baseline gap-4 py-1.5">
      <span className="text-xs text-stone-400 flex-shrink-0">{label}</span>
      <span
        className={`text-sm text-right ${
          value ? "font-semibold text-stone-700" : "text-stone-400 italic"
        }`}
      >
        {value ?? "Not scheduled"}
      </span>
    </div>
  );
}

export default function PatientInfoCard({ userInfo, meta }: PatientInfoCardProps) {
  const generatedDate = meta.generatedAt
    ? new Date(meta.generatedAt).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
      })
    : null;

  return (
    <Card title="Patient Information">
      <div className="mb-4">
        <p className="text-lg font-bold text-stone-800 leading-tight">{userInfo.fullName}</p>
        {userInfo.dateOfBirth && (
          <p className="text-xs text-stone-400 mt-0.5">{userInfo.dateOfBirth}</p>
        )}
      </div>

      <InfoRow label="Delivery Date" value={userInfo.deliveryDate} />
      <InfoRow label="Birth Type" value={userInfo.birthType} />

      <div className="border-t border-stone-100 my-3" />

      <p className="text-xs font-bold tracking-widest uppercase text-stone-400 mb-2">
        Appointments
      </p>
      <InfoRow label="GP 6-Week Check" value={userInfo.gpAppointmentDate} />
      <InfoRow label="Midwife Follow-up" value={userInfo.midwifeDate} />
      <InfoRow label="Summary Period" value={meta.dateRange} />
      <InfoRow label="Generated" value={generatedDate} />
    </Card>
  );
}
